import { ContractShortCodes } from '@modules/bcm/@shared/enums/contract-short-codes';
import { Person } from '@shared/models/person';
import { Boat } from '@shared/models/boat';
import { Tenant } from '@shared/models/tenant';
import { Berth } from '@shared/models/berth';

function uniq(a): [] {
    const prims = {'boolean': {}, 'number': {}, 'string': {}};
    const objs = [];

    return a.filter((item) => {
        const type = typeof item;
        if (type in prims) {
            return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
        } else {
            return objs.indexOf(item) >= 0 ? false : objs.push(item);
        }
    });
}

export function missingContractFieldsPerson(knownShortCodeList: string[],
                                            tenant: Tenant = {} as Tenant,
                                            person: Person = {} as Person,
                                            boat: Boat = {} as Boat,
                                            berth: Berth = {} as Berth): {
    tenant: string[],
    person: string[],
    boat: string[],
    berth: string[],
} {
    const missingFields: {
        tenant: string[],
        person: string[],
        boat: string[],
        berth: string[],
    } = {
        tenant: [],
        person: [],
        boat: [],
        berth: [],
    };

    if (!person) {
        return missingFields;
    }

    const {
        city,
        postCode,
        street,
        country,
        title,
        lastName,
        firstName,
        fullName,
        BIC,
        IBAN,
        Kreditinstitut,
        salutation,
        birthDate,
        mail,
        phone,
        mails,
        phones,
        identNumber,
    } = person;

    for (const code of knownShortCodeList) {
        switch (code) {
            case ContractShortCodes.VE_ADRESSE:
            case ContractShortCodes.VE_ADRESSE_UMBRUCH:
                if (!firstName) {
                    missingFields.person.push('Vorname');
                }
                if (!lastName) {
                    missingFields.person.push('Nachname');
                }
                if (!fullName) {
                    missingFields.person.push('Vollständiger Name');
                }
                if (!street) {
                    missingFields.person.push('Straße');
                }
                if (!postCode) {
                    missingFields.person.push('PLZ');
                }
                if (!city) {
                    missingFields.person.push('Ort');
                }
                break;
            case ContractShortCodes.VE_ANREDE:
                if (salutation == null) {
                    missingFields.person.push('Anrede');
                }
                break;
            case ContractShortCodes.VE_NAME:
                if (!firstName || !lastName) {
                    missingFields.person.push('Vollständiger Name');
                }
                break;
            case ContractShortCodes.VE_NAME_PLUS_TITEL:
                if (!firstName || !lastName) {
                    missingFields.person.push('Vollständiger Name');
                }
                break;
            case ContractShortCodes.VE_STR:
                if (!street) {
                    missingFields.person.push('Straße');
                }
                break;
            case ContractShortCodes.VE_PLZ:
                if (!postCode) {
                    missingFields.person.push('PLZ');
                }
                break;
            case ContractShortCodes.VE_STADT:
                if (!city) {
                    missingFields.person.push('Stadt');
                }
                break;
            case ContractShortCodes.VE_LAND:
                if (!country) {
                    missingFields.person.push('Land');
                }
                break;
            case ContractShortCodes.VE_MAIL:
                if (!mail && !mails?.length) {
                    missingFields.person.push('E-Mail');
                }
                break;
            case ContractShortCodes.VE_TEL:
                if (!phone && !phones?.length) {
                    missingFields.person.push('Telefonnummer');
                }
                break;
            case ContractShortCodes.VE_MOBIL:
                if (!phones?.find(p => p.type === 'Mobil')) {
                    missingFields.person.push('Mobilnummer');
                }
                break;
            case ContractShortCodes.VE_FAX:
                if (!phones?.find(p => p.type === 'Fax')) {
                    missingFields.person.push('Faxnummer');
                }
                break;
            // case ContractShortCodes.VE_WEB:
            //     if (!web) {
            //         missingFields.person.push('Webseite');
            //     }
            //     break;
            case ContractShortCodes.VE_GEBURTSDATUM:
                if (!birthDate) {
                    missingFields.person.push('Geburtsdatum');
                }
                break;
            case ContractShortCodes.VE_BANK_KONTOINHABER :
                if (!firstName || !lastName || !fullName) {
                    missingFields.person.push('Kontoinhaber');
                }
                break;
            case ContractShortCodes.VE_BANK_NAME:
                if (!Kreditinstitut) {
                    missingFields.person.push('Bankname');
                }
                break;
            case ContractShortCodes.VE_BANK_IBAN:
                if (!IBAN) {
                    missingFields.person.push('IBAN');
                }
                break;
            case ContractShortCodes.VE_BANK_BIC:
                if (!BIC) {
                    missingFields.person.push('BIC');
                }
                break;
            case ContractShortCodes.VE_IDENTIFIKATIONSNUMMER:
                if (!identNumber) {
                    missingFields.person.push('Identifikationsnummer');
                }
                break;


            // TENANT
            case ContractShortCodes.VA_ADRESSE:
            case ContractShortCodes.VA_ADRESSE_UMBRUCH:
                if (!tenant.fullAddress) {
                    missingFields.tenant.push('Vollständige Adresse');
                }
                break;
            case ContractShortCodes.VA_NAME:
            case ContractShortCodes.VA_BANK_KONTOINHABER:
                if (!tenant.name) {
                    missingFields.tenant.push('Name');
                }
                break;
            case ContractShortCodes.VA_BANK_NAME:
                if (!tenant.primaryBankAccount?.bankName) {
                    missingFields.tenant.push('Bankname');
                }
                break;
            case ContractShortCodes.VA_BANK_IBAN:
                if (!tenant.primaryBankAccount?.iban) {
                    missingFields.tenant.push('IBAN');
                }
                break;
            case ContractShortCodes.VA_BANK_BIC:
                if (!tenant.primaryBankAccount?.bic) {
                    missingFields.tenant.push('BIC');
                }
                break;
            case ContractShortCodes.VA_FAX:
                if (!tenant.fax) {
                    missingFields.tenant.push('Fax');
                }
                break;
            case ContractShortCodes.VA_MAIL:
                if (!tenant.mail) {
                    missingFields.tenant.push('Mail');
                }
                break;
            case ContractShortCodes.VA_MAIL_2:
                if (!tenant.mail2) {
                    missingFields.tenant.push('2. Mail');
                }
                break;
            case ContractShortCodes.VA_MOBIL:
                if (!tenant.mobile) {
                    missingFields.tenant.push('Mobil');
                }
                break;
            case ContractShortCodes.VA_TEL:
                if (!tenant.phone) {
                    missingFields.tenant.push('Telefon');
                }
                break;
            case ContractShortCodes.VA_WEB:
                if (!tenant.website) {
                    missingFields.tenant.push('Webseite');
                }
                break;


            // BOOT
            case ContractShortCodes.BOOT_NAME :
                if (!boat.name) {
                    missingFields.boat.push('Name');
                }
                break;
            case ContractShortCodes.BOOT_GEWICHT:
                if (!boat.weight) {
                    missingFields.boat.push('Gewicht');
                }
                break;
            case ContractShortCodes.BOOT_TYP:
                if (!boat.type) {
                    missingFields.boat.push('Typ');
                }
                break;
            case ContractShortCodes.BOOT_MODELL:
                if (!boat.model) {
                    missingFields.boat.push('Modell');
                }
                break;
            case ContractShortCodes.BOOT_HERSTELLER :
                if (!boat.manufacturer) {
                    missingFields.boat.push('Hersteller');
                }
                break;
            case ContractShortCodes.BOOT_KENNZEICHEN :
                if (!boat.licensePlate) {
                    missingFields.boat.push('Kennzeichen');
                }
                break;
            case ContractShortCodes.BOOT_HIN:
                if (!boat.HIN) {
                    missingFields.boat.push('HIN');
                }
                break;
            case ContractShortCodes.BOOT_LAENGE :
                if (!boat.length) {
                    missingFields.boat.push('Länge');
                }
                break;
            case ContractShortCodes.BOOT_BREITE:
                if (!boat.width) {
                    missingFields.boat.push('Breite');
                }
                break;
            case ContractShortCodes.BOOT_QM:
                if (!boat.width && missingFields.boat?.indexOf('Breite') <= -1) {
                    missingFields.boat.push('Breite');
                }
                if (!boat.length && missingFields.boat?.indexOf('Länge') <= -1) {
                    missingFields.boat.push('Länge');
                }
                break;


            // Liegeplatz (LP)
            case ContractShortCodes.LP_NAME:
                if (!berth?.handle) {
                    missingFields.berth.push('Name');
                }
                break;
            case ContractShortCodes.LP_BREITE:
                if (!berth?.width) {
                    missingFields.berth.push('Breite');
                }
                break;
            case ContractShortCodes.LP_LAENGE:
                if (!berth?.length) {
                    missingFields.berth.push('Länge');
                }
                break;
            case ContractShortCodes.LP_QM:
                if (!berth?.width) {
                    missingFields.berth.push('Breite');
                }
                if (!berth?.length) {
                    missingFields.berth.push('Länge');
                }
                break;
            case ContractShortCodes.LP_STEG_NAME:
                if (!berth?.pier?.handle) {
                    missingFields.berth.push('Stegname');
                }
                break;


            // Lagerplätze (LAPL)
            case ContractShortCodes.LAPL_NAME:
                if (!person) {
                    missingFields.berth.push('Name');
                }
                break;
            case ContractShortCodes.LAPL_QM:
                if (!person) {
                    missingFields.berth.push('Fläche');
                }
                break;
        }
    }

    missingFields.person = uniq(missingFields.person);
    missingFields.tenant = uniq(missingFields.tenant);
    missingFields.boat = uniq(missingFields.boat);
    missingFields.berth = uniq(missingFields.berth);

    return missingFields;
}
